(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*global $, jQuery, alert, console*/

"use strict";

$(document).ready(function () {

    $('.open-step-btn').on('click', function (e) {
        e.preventDefault();
        var stepSectionId = $(this).attr('href').slice(1);
        $('#' + stepSectionId).addClass('active');
    });

    $('.close-steps-link').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.s-steps').removeClass('active');
    });

    $('.s-steps__checkboxes-item').on('click', function () {
        $(this).closest('.s-steps__checkboxes-list').find('.s-steps__checkboxes-item').each(function () {
            $(this).removeClass('active');
            $(this).removeClass('invalid');
            $(this).find('input[type="checkbox"]').prop('checked', false);
        });
        $(this).addClass('active');
        $(this).find('input[type="checkbox"]').prop('checked', true);

        $(this).closest('.s-steps__step').find('.btn__next-step').addClass('active');

        // $(this).closest('.s-steps__step').removeClass('active').next('.s-steps__step').addClass('active');
    });

    $('.btn__prev-step').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.s-steps__step').removeClass('active').prev('.s-steps__step').addClass('active');
    });

    $('.btn__next-step').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            $(this).closest('.s-steps__step').removeClass('active').next('.s-steps__step').addClass('active');
        } else {
            $(this).closest('.s-steps__step').find('.s-steps__checkboxes-item').each(function () {
                $(this).addClass('invalid');
            })
        }
    });

    $('.btn__next-step-form').on('click', function (e) {
        e.preventDefault();
        if (!$(this).closest('.s-steps__form-step').find('.form-control').hasClass('invalid')) {
            $(this).closest('.s-steps__form-step').removeClass('active').next('.s-steps__form-step').addClass('active');
        }
    });

    $('.btn__prev-step-form').on('click', function (e) {
        e.preventDefault();
        $(this).closest('.s-steps__form-step').removeClass('active').prev('.s-steps__form-step').addClass('active');
    })
});
},{}]},{},[1])